import { useContext } from "react";
import { InfoContext } from "../state/contexts";

function useInfo() {
  return useContext(InfoContext);
}

export default useInfo;
